import { InfosContact } from '@/model/infos-contact';
import Axios from 'axios';
import { ApiUtils } from './api-utils';

export class UserApi {
  static getProfil (): Promise<any> {
    return ApiUtils.responseParser(Axios.get('/web/user/me'));
  }

  static getInfosContact (): Promise<InfosContact[]> {
    return ApiUtils.responseParser(Axios.get('/web/v1/users/me/contact'), [InfosContact]);
  }
}
